import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

// Start this enum from >= 20000 so it doesn't conflict with the
// AttachmentDataProviderType
export const enum AttachmentFolderPickerClientProviderType {
    Group = 20000,
}

export type AttachmentFolderPickerProviderType =
    | AttachmentDataProviderType.OneDrivePro
    | AttachmentFolderPickerClientProviderType.Group;
